import { KeyValue } from '@/main/models/common';
import { getTranslateByKey } from '@/main/services/utils';
import { finalDateForm, initalDateForm } from '@/main/services/utilsDate';
import { z } from 'zod';

const requiredMsg = (fieldKey: string) =>
  getTranslateByKey('information.isRequired', true).replace(
    '{0}',
    getTranslateByKey(fieldKey)
  );

export const searchCancelledPartsSchema = z
  .object({
    claimNumber: z.string().nullable(),
    startDate: z.date(),
    finalDate: z.date(),
    bodyshop: z.array(z.custom<KeyValue>()).nullable(),
    insurer: z.custom<KeyValue>().nullable(),
    supplier: z.custom<KeyValue>().nullable(),
    deliveryAddressState: z.array(z.custom<KeyValue>()).nullable(),
    subModel: z.string(),
    vehicleManufacturer: z.string(),
    vehicleModel: z.string(),
    vehicle: z.string()
  })
  .superRefine((data, ctx) => {
    if (!data.insurer) {
      ctx.addIssue({
        code: 'custom',
        path: ['insurer'],
        message: requiredMsg('information.insurer')
      });
    }
  });

export type ISearchCancelledPartsForm = z.infer<
  typeof searchCancelledPartsSchema
>;

export const getInitialSearchCancelledPartsForm = (
  rangeDays: number
): ISearchCancelledPartsForm => ({
  claimNumber: null,
  startDate: initalDateForm(rangeDays),
  finalDate: finalDateForm(),
  bodyshop: null,
  insurer: null,
  supplier: null,
  deliveryAddressState: null,
  subModel: '',
  vehicleManufacturer: '',
  vehicleModel: '',
  vehicle: ''
});
